import React, { Component } from 'react';
import styled from 'styled-components';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Colors } from 'modules/theme';
import Input from 'components/InputText';
import ButtonText from 'components/ButtonText';
import H4 from 'components/H4';
import FormError from 'components/FormError';
import Line from 'components/Line';
import PropTypes from 'prop-types';

const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
`;

const Column = styled.div`
  flex-direction: column;
  box-sizing: border-box;
  width: 50%;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

const TwoColRow = styled(Row)`
  margin-top: 20px;
  @media (max-width: 767px) {
    margin-top: 24px;
  }
`;

const MainLeftColumn = styled(Column)`
  width: 50%;
  padding-right: 16px;
  @media (max-width: 767px) {
    width: 100%;
    padding-right: 0;
  }
`;

const MainRightColumn = styled(Column)`
  width: 50%;
  padding-left: 16px;
  @media (max-width: 767px) {
    width: 100%;
    padding-left: 0;
    margin-top: 24px;
  }
`;

const FixedFooter = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  background-color: white;
  padding: 15px 30px;
  border-top: 1px solid ${Colors.gray2};
  display: flex;
  justify-content: flex-end;
  z-index: 10;
  @media (max-width: 767px) {
    padding: 12px 16px;
  }
`;

export default class DetailsForm extends Component {
  submit = values => {
    const { onSubmit } = this.props;
    const activeTab = 'Permissions';

    onSubmit(values, activeTab);
  };

  render() {
    const { initialValues, isInitialValid } = this.props;

    return (
      <Formik
        enableReinitialize
        isInitialValid={isInitialValid}
        initialValues={initialValues}
        onSubmit={this.submit}
        validationSchema={Yup.object().shape({
          email: Yup.string()
            .required('Required')
            .email('Invalid Format'),
          first_name: Yup.string().required('Required'),
          last_name: Yup.string().required('Required'),
          phone_number: Yup.string().required('Required'),
        })}
      >
        {({ values, errors, touched, handleChange, handleBlur, isValid }) => (
          <Form style={{ paddingBottom: '80px', maxWidth: '100%', boxSizing: 'border-box' }}>
            <TwoColRow>
              <MainLeftColumn>
                <H4 inputLabel color={Colors.gray8}>
                  First name
                </H4>
                <Input
                  placeholder="First name"
                  name="first_name"
                  value={values.first_name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  icon="bookmark"
                />
                <FormError text={errors.first_name && touched.first_name && errors.first_name} />
                <H4 inputLabel color={Colors.gray8} style={{ marginTop: '16px' }}>
                  Email
                </H4>
                <Input
                  placeholder="Email"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  icon="envelope"
                />
                <FormError text={errors.email && touched.email && errors.email} />
              </MainLeftColumn>
              <MainRightColumn>
                <H4 inputLabel color={Colors.gray8}>
                  Last name
                </H4>
                <Input
                  placeholder="Last name"
                  name="last_name"
                  value={values.last_name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  icon="bookmark"
                />
                <FormError text={errors.last_name && touched.last_name && errors.last_name} />
                <H4 inputLabel color={Colors.gray8} style={{ marginTop: '16px' }}>
                  Phone number
                </H4>
                <Input
                  placeholder="Phone number"
                  name="phone_number"
                  value={values.phone_number}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  icon="phone"
                />
                <FormError
                  text={errors.phone_number && touched.phone_number && errors.phone_number}
                />
              </MainRightColumn>
            </TwoColRow>
            <Row style={{ marginTop: '30px' }}>
              <Line />
            </Row>

            <FixedFooter>
              <ButtonText text="Next" theme="primary" type="submit" disabled={!isValid} />
            </FixedFooter>
          </Form>
        )}
      </Formik>
    );
  }
}

DetailsForm.propTypes = {
  initialValues: PropTypes.object,
  isInitialValid: PropTypes.bool,
  onSubmit: PropTypes.func,
};
